var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50006 15.9999C7.32849 15.9999 8.00006 15.3283 8.00006 14.4999C8.00006 13.6715 7.32849 12.9999 6.50006 12.9999C5.67163 12.9999 5.00006 13.6715 5.00006 14.4999C5.00006 15.3283 5.67163 15.9999 6.50006 15.9999Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3H5.5C4.0418 3.00159 2.64377 3.58156 1.61267 4.61267C0.581561 5.64377 0.00158817 7.0418 0 8.5L0 15.5C0.00158817 16.9582 0.581561 18.3562 1.61267 19.3873C2.64377 20.4184 4.0418 20.9984 5.5 21H18.5C19.9582 20.9984 21.3562 20.4184 22.3873 19.3873C23.4184 18.3562 23.9984 16.9582 24 15.5V8.5C23.9984 7.0418 23.4184 5.64377 22.3873 4.61267C21.3562 3.58156 19.9582 3.00159 18.5 3ZM5.5 6H18.5C19.0762 6.00011 19.6346 6.19923 20.0808 6.56366C20.5271 6.9281 20.8338 7.43549 20.949 8H3.051C3.16623 7.43549 3.47291 6.9281 3.91916 6.56366C4.36541 6.19923 4.92385 6.00011 5.5 6ZM18.5 18H5.5C4.83696 18 4.20107 17.7366 3.73223 17.2678C3.26339 16.7989 3 16.163 3 15.5V11H21V15.5C21 16.163 20.7366 16.7989 20.2678 17.2678C19.7989 17.7366 19.163 18 18.5 18Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardWhite);
export default __webpack_public_path__ + "static/media/credit_card_white.4441aac691659952851080dd85fd44b5.svg";
export { ForwardRef as ReactComponent };